// src/components/DonationSidebar.tsx
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DonationSidebar: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Don't show on home page
    if (location.pathname === '/') {
      setIsVisible(false);
      return;
    }

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Show sidebar only when at the top of the page (less than 100px scrolled)
      setIsVisible(scrollTop < 100);
    };

    // Initial check
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  // Don't render anything on home page or when not visible
  if (location.pathname === '/' || !isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      right: '20px',
      top: '50%',
      transform: 'translateY(-50%)',
      backgroundColor: 'var(--card-bg)',
      border: '1px solid var(--border)',
      borderRadius: '12px',
      padding: '20px',
      width: '280px',
      boxShadow: '0 4px 20px var(--shadow)',
      zIndex: 100,
      transition: 'opacity 0.3s ease, transform 0.3s ease'
    }}>
      <h4 style={{ 
        marginBottom: '12px', 
        color: 'var(--text-primary)',
        fontSize: '16px'
      }}>
        Support Our Mission
      </h4>
      <p style={{ 
        color: 'var(--text-secondary)', 
        fontSize: '14px',
        marginBottom: '16px',
        lineHeight: '1.5'
      }}>
        Your support helps me maintain this platform and spread Islamic knowledge.
      </p>
      <a 
        href="/donate" 
        className="btn-primary"
        style={{
          display: 'block',
          textAlign: 'center',
          textDecoration: 'none',
          fontSize: '14px',
          padding: '10px 16px'
        }}
      >
        Donate Now
      </a>
    </div>
  );
};

export default DonationSidebar;